<template>
  <div class="detail">
    <GlobalInfoBar :title="title" />
    <GlobalChunk icon="order" title="订单信息" :padding="[20, 20, 20, 20]">
      <el-form ref="form" :model="form" label-width="160px">
        <div v-for="(item, index) in formItems" :key="index">
          <el-form-item :label="item.label" :key="item.prop">
            <div v-if="item.type === 'div'">{{ form[item.prop] }}</div>

            <!--输入框-->
            <el-input v-if="item.type === 'input'" v-model="form[item.prop]" :placeholder="'请输入' + item.label"
              :disabled="item.disabled"></el-input>

            <!--textarea-->
            <el-input v-if="item.type === 'textarea'" v-model="form[item.prop]" type="textarea"
              :placeholder="'请填写' + item.label" :disabled="item.disabled"></el-input>

            <!--radio-->
            <el-radio-group v-if="item.type === 'radio' && item.optListName" v-model="form[item.prop]"
              @change="selectChange(item.relate, item.hx)">
              <el-radio style="margin-bottom: 10px" v-for="opt in getOptions(item.optListName)"
                :key="opt[item.optLabel]" :label="opt[item.optValue]">{{ opt[item.optLabel] }}
              </el-radio>
            </el-radio-group>

                   <!--日期框-->
            <el-date-picker
              v-if="item.type === 'date'"
              v-model="form[item.prop]"
              align="right"
              type="date"
              :placeholder="'请选择' + item.label"
              value-format="yyyy-MM-dd"
              :disabled="item.disabled"
            >
            </el-date-picker>

            <!--img-->
            <div v-if="item.type === 'img'">
              <!--          order.tem_img-->
              <div>（点击图片查看大图）</div>

              <div style="display: flex">
                <el-image v-if="form[item.prop]" class="preview-img" style="margin-right: 20px; margin-bottom: 20px"
                  :src="form[item.prop]" :preview-src-list="[form[item.prop]]" :data-watermark="!!item.watermark"
                  @click.stop="closePreview">
                </el-image>
                <div class="original-pic" v-if="
                  formData[item.obj] &&
                  formData[item.obj]['old' + item.prop.replace('tem', '')]
                ">
                  <el-image class="preview-img" :src="formData[item.obj] &&
                    formData[item.obj]['old' + item.prop.replace('tem', '')]
                    " :preview-src-list="[
                      formData[item.obj] &&
                      formData[item.obj][
                      'old' + item.prop.replace('tem', '')
                      ],
                    ]" :data-watermark="!!item.watermark" @click.stop="closePreview">
                  </el-image>
                  <div class="mark">原图</div>
                </div>

                <el-upload :ref="item.prop" v-if="!form[item.prop]" action="#" list-type="picture-card" :limit="1"
                  show-file-list :auto-upload="false" :on-change="(file) => {
                    getFile(file, item.prop);
                  }
                    ">
                  <i slot="default" class="el-icon-plus"></i>
                </el-upload>
              </div>

              <div class="img-operation">
                <el-button plain size="mini" @click="uploadImg(item.prop)" v-if="form[item.prop]">编辑
                </el-button>


              </div>
            </div>

          </el-form-item>

        </div>

        <div class="bottom-btns">
          <el-button type="success" @click="setorderJudge">提交审核</el-button>
        </div>
      </el-form>
    </GlobalChunk>

    <GlobalChunk style="margin-top: 20px" icon="order" title="注册信息" :padding="[20, 20, 20, 20]">
      <GlobalTable ref="GlobalTable" :columns="tableColumns" :data="[formData.member || {}]" :isPagination="false">
        <el-table-column label="微信头像" slot="headimg" align="center">
          <template slot-scope="{ row }">
            <el-image class="head-img" :src="row.headimg" :preview-src-list="[row.headimg]" @click.stop="closePreview">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column label="操作" slot="operation" align="center">
          <template slot-scope="{ row }">
            <el-button type="success" @click="sendMessageToWX(row)" size="mini" style="border-radius: 50px">微信发送消息
            </el-button>
          </template>
        </el-table-column>
      </GlobalTable>
    </GlobalChunk>




    <el-dialog title="提示" :visible.sync="centerDialogVisible" width="400px">
      <span>{{ dialogText }}</span>
      <span slot="footer">
        <el-button type="primary" @click="goback()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/utils/request";
import { wxRefund } from "@/utils/request/partnerManage";
import dateFormat from "@/utils";

export default {
  props: {
    type: [String, Number],
    orderId: [String, Number],
  },
  data() {
    return {
      cardIddata: "",
      submitShow: false,
      centerDialogVisible: false,
      dialogText: "",
      //处理前的数据
      formData: {},
      //表单项配置
      formItems: [],
      form: {},
      title: "",
      orderType: "",

      brandList: [],
      modelList: [],
      gearList: [],
      RAMList: [],
      IDcard: [
        { name: "大陆身份证", status: 1 },
        { name: "港澳天身份证", status: 2 },
      ],
      netStandardList: [],
      phoneStatusList: [],
      phoneScreenStatusList: [],
      serviceList: [],
      serviceScreenList: [
        "免费换屏幕",
        "免费换后盖",
        "免费换电池",
        "质量问题换机",
      ],
      serviceScreenList2: [
        "免费换屏幕",
        "免费换后盖",
        "免费换电池",
        "免费延保",
      ],
      serviceScreenList3: [
        "免费换屏幕",
        "免费换后盖",
        "免费换电池",
        "免费延保",
        "折抵换机",
        "进水保修",
      ],
      maintainList: ["在购机门店维修", "本地维修点维修", "邮寄至成都总部维修"],
      statusList: [],
      personalReimbursementList: [
        { name: "是", value: 1 },
        { name: "否", value: 0 },
      ],
      changeMethodList: [],
      changeIMEIReasonList: [],
      changeIMEITypeList: [],
      repairTypeList: [],
      idFlag: false,
      repairMethodList: [],
      iphoneServeList: [],
      upServerList: [],
      androidServeList: [],
      iphoneNnhxServeList: [],
      androidNnhxServeList: [],
      isUpgradeList: ["同代同型换新机", "迭代升级换新机"],
      photoResubmissionTypeList: [],
      logisticsList: [],
      orderTypeList: [
        { id: "01", name: "个人" },
        { id: "31", name: "商家" },
      ],
      chooseList: [
        { id: 1, name: "是" },
        { id: 0, name: "否" },
      ],

      tableColumns: [],
      tableData: [],
      piccCallbackType: "",
      temp: {},
      imeiData: null,
      queryDetail: "",
      official_price: "", //官网价
      price: "", //协议价
      machineType: 1, //1 ios,2安卓
      orderJudgeVisible: false,
      orderJudgeOptions: [],
      orderJudgeValue: "",
      verifyCodeValue: "",
    };
  },
  computed: {
    getOptions() {
      return (optsName) => {
        return this[optsName];
      };
    },

  },
  mounted() {
    this.init();
  },
  watch: {
    $route() {
      this.init();
    },
  },
  methods: {
    setorderJudge() {
      console.log('this.form', this.form);
      const { tem_img, exa_status, fail_exp } = this.form
      api.examineYidong({ tem_img, exa_status, fail_exp, order_id: this.orderId }).then((res) => {
        this.$message.success(res.msg || "审核成功");
        this.$router.push('/dashboard');
      })
    },


    init() {
      this.getOrder();
      //获取配置
      let currentForm = require(`./orderType${this.type}.js`);

      this.formItems = currentForm.form;
      this.idFlag = currentForm.idFlag;
      this.tableColumns = currentForm.tableColumns;
      this.piccCallbackType = currentForm.piccCallbackType;
      this.orderType = currentForm.type || "";
      let title = currentForm.name + "订单详情";
      this.title = title;
      window.document.title = title;
    },
    getOrder() {
      api.acceptInfoYidong({ order_id: this.orderId }).then((res) => {
        if (res.code == 233) {
          this.dialogText = res.msg;
          this.centerDialogVisible = true;
        } else {
          console.log(res);
          this.cardIddata = res.data || {};
          this.queryDetail = res.data.query;
          let formData = res.data || {};
          this.formData = formData;
          this.official_price = this.formData.phonePrice?.official_price || "";
          this.price = this.formData.phonePrice?.price || "";
          this.machineType = this.formData.order.type;
          let form = {};
          this.formItems.forEach((item) => {
            if (formData[item.obj] && item.prop) {
              form[item.prop] = formData[item.obj][item.prop];
              //临时prop，比如时间范围选择需要起始时间两个属性生成一个临时属性
            } else if (item.tempProp) {
              let tempProp = "";
              if (
                item.tempProp === "dateRange_term_time" ||
                item.tempProp === "dateRange_term_time2"
              ) {
                tempProp = [
                  formData[item.obj][item.props[0]] || "",
                  formData[item.obj][item.props[1]] || "",
                ];
              }
              this.$set(this.temp, item.tempProp, tempProp);
              item.props.forEach((p) => {
                form[p] = formData[item.obj][p];
              });
            }
            //通过optListName获取数组
            if (item.optListName) {
              this.getListByName(item.optListName);
            }
          });
          this.form = form;
          this.gearList = formData.order.select_gear;

          if (res.data.options) {
            let statusList = [];
            Object.keys(res.data.options).forEach((key) => {
              let isNumberKey = new RegExp(/^\d+$/).test(key);
              statusList.push({
                status: isNumberKey ? parseInt(key) : key,
                name: res.data.options[key],
              });
            });
            this.statusList = statusList;
          }
        }
      });
    },
    goback() {
      this.$router.back();
    },
    getListByName(name) {
      if (typeof name !== "string") {
        return;
      }
      //拼接获取数组的方法
      let functionName =
        "get" + name.replace(/^[a-z]/, (initial) => initial.toUpperCase());
      if (typeof this[functionName] === "function") {
        this[functionName]();
      }
    },
    uploadImg(prop) {
      this.form[prop] = "";
    },
    getFile(file, prop) {
      let formData = new FormData();
      formData.append("file", file.raw);
      // 上传图片
      api.imageUp(formData).then((res) => {
        this.form[prop] = res.data.url;
        // 工单--图片上传回来后，调用接口直接改订单图片
        // console.log(this.form,'22222哈哈哈哈');
        // console.log(this.orderId,'33333哈哈哈哈');
        // console.log(prop,'哈哈哈哈');
        if (prop == "tem_work") {
          api
            .orderImgUp({
              id: this.orderId,
              url: res.data.url,
              name: "tem_work",
              type: this.type == 13 ? 2 : 1,
            })
            .then((res) => {
              this.$message.success(res.msg || "已更新图片");
            });
        }
        if (prop == "tem_work2") {
          api
            .orderImgUp({
              id: this.orderId,
              url: res.data.url,
              name: "tem_work2",
              type: this.type == 13 ? 2 : 1,
            })
            .then((res) => {
              this.$message.success(res.msg || "已更新图片");
            });
        }
        if (prop == "tem_work3") {
          api
            .orderImgUp({
              id: this.orderId,
              url: res.data.url,
              name: "tem_work3",
              type: this.type == 13 ? 2 : 1,
            })
            .then((res) => {
              this.$message.success(res.msg || "已更新图片");
            });
        }


        if (prop == "tem_card") {
          api
            .orderImgUp({
              id: this.orderId,
              url: res.data.url,
              name: "tem_card",
              type: 4,
            })
            .then((res) => {
              this.$message.success(res.msg || "已更新图片");
            });
        }
        if (prop == "tem_back") {
          api
            .orderImgUp({
              id: this.orderId,
              url: res.data.url,
              name: "tem_back",
              type: 4,
            })
            .then((res) => {
              this.$message.success(res.msg || "已更新图片");
            });
        }
        if (prop == "tem_receive") {
          api
            .orderImgUp({
              id: this.orderId,
              url: res.data.url,
              name: "tem_receive",
              type: 4,
            })
            .then((res) => {
              this.$message.success(res.msg || "已更新图片");
            });
        }
      });
    },
    closePreview(event) {
      // 获取遮罩层dom
      setTimeout(() => {
        let domImageMask = document.querySelector(".el-image-viewer__wrapper");
        if (!domImageMask) {
          return;
        }
        domImageMask.addEventListener("click", (e) => {
          if (
            e.target.parentNode.className ===
            "el-image-viewer__actions__inner" ||
            e.target.parentNode.className === "el-image-viewer__canvas"
          ) {
            return; //如果点击底部菜单，不关闭
          }
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector(".el-image-viewer__close").click();
        });

        //添加水印
        if (event.target.dataset.watermark) {
          let div = document.createElement("div");
          let text = "";
          if (this.form.card_secret) {
            text += `<p>卡密：${this.form.card_secret}</p>`;
          }
          if (this.form.card_num) {
            text += `<p>卡号：${this.form.card_num}</p>`;
          }
          if (this.form.imei) {
            text += `<p>IMEI码：${this.form.imei}</p>`;
          }
          if (this.form.card_name) {
            text += `<p>销售商家：${this.form.card_name}</p>`;
          }
          div.innerHTML = text;
          div.classList = ["watermark"];
          domImageMask.appendChild(div);
        }
      }, 300);
    },

    getModelList(brand_id) {
      api.pullModelList({ brand_id }).then((res) => {
        this.modelList = res.data || [];
      });
    },
    getLogisticsList() {
      api.getLogisticsList().then((res) => {
        this.logisticsList = res.data;
      });
    },
    selectChange(relate, hx) {
      console.log('111', relate, hx);

      console.log("hx");
      if (hx === "hx") {
        console.log(123);
        if (this.form.exa_status === 1) {
          if (this.type == 1 || this.type == 4) {
            this.form.fail_exp =
              "碎屏险注册成功，服务自注册成功当天15日后生效，服务期内出现进液、进水，私拆、私修情况均不在理赔范围之内，需维修时请在公众平台提交碎屏险理赔申请";
          }
        } else {
          this.form.fail_exp = "";
        }
      }
    },



    sendMessageToWX(row) {
      api
        .sendWxPush({ mold: this.type, order_id: this.orderId })
        .then((res) => {
          this.$message.success(res.msg || "推送成功");
        })
        .catch((err) => { });
    },

  },
};
</script>

<style scoped lang="scss">
.rong {
  display: inline-block;
  background-color: #f2f9f0;
  color: #80c27f;
  padding: 0 6px;
  border-radius: 6px;
  line-height: 30px;
}

.el-input,
.el-select,
.el-date-picker,
.el-textarea,
.el-date-editor,
::v-deep .el-input__inner {
  width: 500px !important;
}

.preview-img {
  width: 148px;
  height: 148px;
  border-radius: 5px;
}

.head-img {
  width: 50px;
  height: 50px;
}

.img-operation {
  display: flex;
  line-height: 1em;
  align-items: flex-end;

  .notice {
    color: red;
    font-size: 12px;
  }

  .el-button {
    margin-right: 10px;
  }
}

::v-deep .el-upload {
  margin-bottom: 15px;
}

.bottom-btns {
  margin-left: 160px;
}

.picc-callback {
  background: #f5f6fa;
  border-radius: 10px;
  display: flex;
  flex-wrap: wrap;
  padding: 20px;

  .item {
    margin-bottom: 20px;
    display: flex;
    align-items: center;

    .name {
      color: #999;
    }

    .value {
      color: #666;

      .el-button {
        border-radius: 50px;
      }
    }
  }

  .item:nth-child(2n-1) {
    width: 33.3%;
  }

  .item:nth-child(2n) {
    width: 66.6%;
  }
}

.warning span {
  color: red;
  font-size: 18px;
  font-weight: bold;
}

.append {
  margin-left: 20px;

  .el-button:hover {
    color: red;
  }
}

.original-pic {
  position: relative;
  margin-right: 20px;
  margin-bottom: 20px;

  .mark {
    position: absolute;
    top: 0;
    right: 0;
    background: rgba(15, 139, 245, 0.5);
    color: #fff;
    border-bottom-left-radius: 10px;
    padding: 0 10px;
    line-height: 26px;
  }
}

::v-deep .watermark {
  position: absolute;
  left: 220px;
  max-width: 400px;
  line-height: 1.5em;
  word-break: break-all;
  top: 60px;
  color: #fff;
  background: #00000080;
  border-radius: 10px;
  padding: 15px;
}

.detail {
  position: relative;
}

.other-info {
  display: flex;
  position: absolute;
  left: 750px;
  top: 170px;

  .sub-insurance,
  .photo-resubmission {
    width: 300px;

    .title {
      font-weight: bold;
      position: relative;

      &:before {
        content: "";
        display: block;
        width: 4px;
        height: 15px;
        background: #0981ff;
        position: absolute;
        left: -10px;
        top: 50%;
        transform: translateY(-50%);
      }

      .total-cost {
        font-weight: normal;
        font-size: 14px;
        margin-left: 20px;
        color: red;
      }
    }
  }
}
</style>
